import React, { Component } from "react";
import { connect } from "react-redux";
import { userInRoles, UserRoleTypeEnum } from "../services/authService";

class VerifyRole extends Component {
  render() {
    const { user, requiredRoles, children } = this.props;
    return userInRoles(user, requiredRoles) ? children : null;
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user
  };
}

export default connect(mapStateToProps)(VerifyRole);
